import { useCallback, useState } from "react";

export type Theme = "light" | "dark";

const KEY = "bee_theme";

const current = (): Theme => (document.documentElement.dataset.theme === "light" ? "light" : "dark");

/** The initial theme is applied by index.html before first paint; this flips and persists it. */
export function useTheme(): [Theme, () => void] {
  const [theme, setTheme] = useState<Theme>(current);
  const toggle = useCallback(() => {
    const next: Theme = current() === "dark" ? "light" : "dark";
    document.documentElement.dataset.theme = next;
    try {
      localStorage.setItem(KEY, next);
    } catch {
      /* storage unavailable: theme lasts for this page only */
    }
    setTheme(next);
  }, []);
  return [theme, toggle];
}
